import {Route, Routes} from 'react-router-dom';

import {List} from './List';

export default function DeclareRegisterInvoice() {

  return (
    <Routes>
      <Route path="/" element={<List/>}/>
    </Routes>
  );
}
